<fieldset class="rating">
  <ng-container *ngFor="let ratingId of ratingArr;index as i">
    <input type="radio" id="{{id}}_{{i}}" name="{{id}}_rating" value="{{ratingArr.length - i}}"
      [checked]="ratingArr.length - i === rating" (click)="onClick(ratingArr.length - i)" />
    <label class="full" for="{{id}}_{{i}}"></label>
  </ng-container>
</fieldset>